export type CopyTextResult = "clipboard" | "prompt";

/** Copy text when the Clipboard API is available, with an explicit manual fallback. */
export async function copyText(text: string, promptLabel = "Copy this link:"): Promise<CopyTextResult> {
    const clipboard = navigator.clipboard;
    if (!clipboard?.writeText) {
        window.prompt(promptLabel, text);
        return "prompt";
    }

    try {
        await clipboard.writeText(text);
        return "clipboard";
    } catch {
        // Clipboard access can be rejected by browser permissions or an
        // insecure context. Keep the generated link available to the user.
        window.prompt(promptLabel, text);
        return "prompt";
    }
}
